import Button from "@ui-kit/form/Button/Button.web";
import CartTotal from "@app-contexts/public/features/basket/components/CartTotal/CartTotal.web";
import CheckoutLabel from "@/components/organisms/purchases/CheckoutLabel";
import useRedirect from "@shared/hooks/useRedirect";
import { usePublicBasket } from "@app-contexts/public/features/basket/services/usePublicBasket";
import url from "@shared/utils/urls/url";
import Box from "@ui-kit/layout/Box/Box.web";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import { useTranslation } from "next-i18next";
import { useCallback } from "react";
import { NestedPublicVenueSerializer } from "@shared/modules/events/types/public";

export default function ModalFooterButtons({
  venue = undefined,
  onClose,
  isDynamicHold = false,
  hasAdditionalItems = false,
}: {
  venue?: NestedPublicVenueSerializer;
  onClose: () => void;
  isDynamicHold?: boolean;
  hasAdditionalItems?: boolean;
}) {
  const { redirect } = useRedirect();
  const { t } = useTranslation("common");
  const { hasItems, isBasketUpdating } = usePublicBasket();
  const onModalClose = useCallback(() => {
    if (isDynamicHold) {
      // TODO: Remove asWindow when checkout exists in NextJS
      return redirect(url("checkout"), { asWindow: true });
    }

    return onClose();
  }, [isDynamicHold, onClose, redirect]);

  return (
    <Flex
      width="full"
      alignItems="center"
      justifyContent={{ base: "space-between", xs: "flex-end" }}
    >
      {isDynamicHold ? (
        <Button
          data-testid={
            !hasAdditionalItems
              ? "modal-footer-buttons-close"
              : "modal-footer-buttons-continue-shopping"
          }
          variant="outline"
          colorPalette="primary"
          minWidth="140px"
          onClick={onClose}
          mr="auto"
        >
          {!hasAdditionalItems ? t("Close") : t("Continue Shopping")}
        </Button>
      ) : (
        <Box mr="lg">
          <CartTotal venue={venue} includeTotal={false} />
        </Box>
      )}

      <Button
        data-testid={
          isDynamicHold
            ? "modal-footer-buttons-checkout"
            : "modal-footer-buttons-continue"
        }
        variant="solid"
        colorPalette="primary"
        minWidth="140px"
        onClick={onModalClose}
        isLoading={isBasketUpdating}
        disabled={!hasItems || isBasketUpdating}
      >
        {isDynamicHold ? <CheckoutLabel /> : t("Continue")}
      </Button>
    </Flex>
  );
}
